import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { CONSTRUCTION_BUILDING_OPTIONS, EPS_OPTIONS } from '~/constants/domain-specific';
import { COVER_DETAILS_BUILDING_AND_CONTENTS_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewBuildingAndContents: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.buildingAndContents' });

  const { buildingSI, contentsSI, construction, eps, yearBuilt, sprinkler, flood } =
    useCoverDetails();

  const coverDetailsReviewList = [
    {
      label: getTextContent('buildingSumInsured'),
      data: currencyFormatter(buildingSI, CurrencyFormat.Comma),
    },
    {
      label: getTextContent('contentsSumInsured'),
      data: currencyFormatter(contentsSI, CurrencyFormat.Comma),
    },
    {
      label: getTextContent('buildingConstruction'),
      data: CONSTRUCTION_BUILDING_OPTIONS.find((o) => o.value === construction)?.text,
    },
    {
      label: getTextContent('eps'),
      data: EPS_OPTIONS.find((o) => o.value === eps)?.text,
    },
    {
      label: getTextContent('yearBuilt'),
      data: yearBuilt,
    },
    {
      label: getTextContent('sprinklers'),
      data: sprinkler ? 'Yes' : 'No',
    },
    {
      label: getTextContent('flood'),
      data: flood ? 'Yes' : 'No',
    },
  ];

  return (
    <ReviewList
      list={
        coverDetailsReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.BuildingAndContents}
      editRoute={COVER_DETAILS_BUILDING_AND_CONTENTS_ROUTE}
    />
  );
};

export default ReviewBuildingAndContents;
